export default "__VITE_ASSET__Bw4p$rIB__"